import graphqlClient from "@/GQLClient";
import {
  GetSummarizedMealsOnMyInstitutionDocument,
  type Meal,
  type EntityPagerFilter,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import type { IPagerResult } from "@/interfaces";

const getMeals = async (
  filter: EntityPagerFilter,
): Promise<IPagerResult<Meal>> => {
  const response = await graphqlClient.query({
    query: GetSummarizedMealsOnMyInstitutionDocument,
    variables: {
      filter,
    },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  });

  if (response.data.institutions?.getMyInstitution.meals) {
    const { edges, pageInfo } =
      response.data.institutions.getMyInstitution.meals;
    return {
      edges: edges.map((item) => item.node as Meal),
      pageInfo,
    };
  }

  throw new SentryGraphQLError(`api.meals.getMeals`, response);
};

export default {
  getMeals,
};
